import { IProduct } from 'shared/types/analytics';

export const getOfferProduct = (offerId: number, position: number): IProduct => ({
  id: offerId,
  offerType: 'offer',
  position,
});
